import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import VideoTopicsCreateEditForm from './Components/VideoTopicsCreateEditForm';
import VideoTopicsApi from './VideoTopicsApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: VideoTopicsCreateEditForm,
                getCreate: VideoTopicsApi.create,
                getClone: VideoTopicsApi.getOne,
                defaults: {},
                successMessage: "VideoTopics Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}